import { render } from "./FilterModal.vue?vue&type=template&id=b2b62cca&scoped=true"
import script from "./FilterModal.vue?vue&type=script&lang=js"
export * from "./FilterModal.vue?vue&type=script&lang=js"

import "./FilterModal.vue?vue&type=style&index=0&id=b2b62cca&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2b62cca"]])

export default __exports__